import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import '../styles/CTA.css';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <h2>Siap Bergabung Bersama Kami?</h2>
        <p>
          Daftarkan diri Anda sekarang dan jadilah bagian dari generasi 
          tenaga kesehatan profesional Indonesia
        </p>
        <div className="cta-buttons">
          <Link to="/pendaftaran" className="btn btn-accent">
            Daftar Sekarang
          </Link>
          <Link to="/kontak" className="btn btn-outline">
            Hubungi Kami
          </Link>
        </div>
        <div className="cta-info">
          <div className="cta-info-item">
            <FontAwesomeIcon icon={faCalendarAlt} />
            <span>Pendaftaran: Januari - Agustus 2026</span>
          </div>
          <div className="cta-info-item">
            <FontAwesomeIcon icon={faPhone} />
            <span>0858-2487-1455</span>
          </div>
          <div className="cta-info-item">
            <FontAwesomeIcon icon={faWhatsapp} />
            <span>0858-2487-1455</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
